<template>
  <v-tabs-items v-model="tabsInit">
    <div v-show="isVisibleProp"></div>
    <v-tab-item eager class="ma-3">
      <GeneralDetailsForm :baseCrudKey="baseCrudKey" :baseCrudKeyForFeeList="baseCrudKeyForFeeList"
      :feeListBasedInIds="feeListBasedInIds" @upsertItem="upsertItem"
      @delinquentRefresh="$emit('delinquentRefresh')" />
    </v-tab-item>
    <v-tab-item eager class="ma-3">
      <OwnerDetailsForm :baseCrudKey="baseCrudKey" />
    </v-tab-item>
    <v-tab-item>
      <Comments :selectedRowItem="editedItem" :mainCompBaseCrudKey="baseCrudKey" />
    </v-tab-item>
    <v-tab-item>
      <Adjustments :selectedRowItem="editedItem" :taxRollBaseCrudKey="baseCrudKey"
      @loadCRUDList="loadCRUDList" />
    </v-tab-item>
    <v-tab-item class="ma-5">
      <TaxMobileDialog :baseCrudKey='baseCrudKey' :isItFromTaxMobile="false" />
    </v-tab-item>
    <v-tab-item>
      <HistoryTransactionList :mainCompBaseCrudKey='baseCrudKey' />
    </v-tab-item>
    <v-tab-item class="ma-5">
      <webUtil :baseCrudKey='baseCrudKey'  />
    </v-tab-item>
  </v-tabs-items>
</template>

<script>
import {
  mapGetters, mapMutations, mapActions, mapState,
} from 'vuex';
import OwnerDetailsForm from './OwnerDetailsForm.vue';
import GeneralDetailsForm from './GeneralDetailsForm.vue';
import Adjustments from './Adjustments.vue';
import Comments from './CommentsTransactionList.vue';
import TaxMobileDialog from './TaxMobileDialog.vue';
import HistoryTransactionList from './HistoryTransactionList.vue';
import webUtil from './WebUtils.vue';
import { isFnNineKey, isFnTenKey } from '../../../../util/shared/vue-global';
import { commonFuncForConsolidateView } from '../../common-utils/tax-common.util';

export default {
  name: 'TaxInquiryDialog',
  components: {
    OwnerDetailsForm,
    GeneralDetailsForm,
    Adjustments,
    Comments,
    TaxMobileDialog,
    HistoryTransactionList,
    webUtil,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'TaxInquiryDialog',
    },
    baseCrudKeyForFeeList: {
      type: String,
      default: 'baseCrudKeyForFeeList',
    },
    feeListBasedInIds: {
      type: Array,
      default: () => ([]),
    },
    attachmentConstants: {
      type: Object,
      default: () => { },
    },
  },
  data: () => ({
    tabVal: 0,
  }),
  destroyed() {
    window.removeEventListener('keydown', this.handleSelShortCutDialog);
  },
  watch: {
    isVisibleProp: {
      immediate: true,
      handler(val) {
        if (val) {
          window.addEventListener('keydown', this.handleSelShortCutDialog);
        } else window.removeEventListener('keydown', this.handleSelShortCutDialog);
      },
    },
    isVisiblePaymentTransactionList(val) {
      // this is for when the dialog is opened or closed, remove or add the shortcut key listener,
      // payment also has its own listener for the shortcut key
      if (val) {
        window.removeEventListener('keydown', this.handleSelShortCutDialog);
      } else window.addEventListener('keydown', this.handleSelShortCutDialog);
    },
    isVisibleProtestAndPickListTabs(val) {
      // this is for when the dialog is opened or closed, remove or add the shortcut key listener,
      // payment also has its own listener for the shortcut key
      if (val) {
        window.removeEventListener('keydown', this.handleSelShortCutDialog);
      } else window.addEventListener('keydown', this.handleSelShortCutDialog);
    },
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
      'selectedTab', 'isVisible',
    ]),
    ...mapState({
      isVisiblePaymentTransactionList: (state) => state.base.crud.isVisible.paymentTransactionList,
      isVisibleProtestAndPickListTabs: (state) => state.base.crud.isVisible.ProtestAndPickListTabs,
    }),
    tabsInit: {
      get() {
        return this.selectedTab(this.baseCrudKey);
      },
      set(value) {
        this.setSelectedTab([this.baseCrudKey, value]);
      },
    },
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    isVisibleProp() {
      const isVisible = this.isVisible(this.baseCrudKey);
      if (isVisible) {
        if (this.editedItem._id) {
          this.loadFiles();
        }
      }
      return isVisible;
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setItem',
      'setSelectedTab',
    ]),
    ...mapActions('files', [
      'loadAttachedFiles',
    ]),
    ...mapActions(['flashSuccess']),
    loadFiles() {
      this.loadAttachedFiles({
        bucketName: this.attachmentConstants.bucketName,
        program: this.attachmentConstants.program,
        parentObjectType: this.attachmentConstants.parentObjectType,
        parentObjectId: this.editedItem._id,
      });
    },
    loadCRUDList() {
      this.$emit('loadCRUDList', {}, 'fromTaxInquiryDialog');
    },
    upsertItem(isFromTaxInquiryDialog, overrideValidate = false) {
      this.$emit('upsertItem', isFromTaxInquiryDialog, overrideValidate);
    },
    handleSelShortCutDialog(e) {
      const activeTag = document.activeElement && document.activeElement.tagName;
      const isInputFocused = activeTag === 'INPUT' || activeTag === 'TEXTAREA' || activeTag === 'SELECT';
      if (isInputFocused) return;

      const isFnNineKeyPres = isFnNineKey(e);
      const isFnTenKeyPres = isFnTenKey(e);
      const doesItHaveData = Object.keys(this.editedItem).length || 0;
      if (isFnNineKeyPres && doesItHaveData) {
        navigator.clipboard.writeText(this.editedItem.legalDesc || '');
        this.flashSuccess('Legal Description copied to clipboard.');
      }
      if (isFnTenKeyPres && doesItHaveData) {
        const consolidateView = commonFuncForConsolidateView(this.editedItem, true);
        navigator.clipboard.writeText(consolidateView || '');
        this.flashSuccess('Owner Information copied to clipboard.');
      }
    },
  },
};
</script>
